import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const LeaveTypeRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--leave-type']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
